import React from 'react';
import * as styles from '../css/highlighted-text.css';

const HighlightedText: React.FC = props => (
    <span className={styles.root} {...props} />
);

export default HighlightedText;
